import apiClient from '@/lib/api';
import { Rating, RatingResponse } from '@/types/rating';

export const ratingsApi = {
  /**
   * Submit or update a rating for a place.
   */
  rate: (userId: string, placeId: string, rating: number): Promise<RatingResponse> => {
    return apiClient.post(`/api/users/${userId}/rate`, {
      placeId,
      rating,
    }).then(res => res.data);
  },

  /**
   * Get all ratings for a user.
   */
  getUserRatings: (userId: string): Promise<Rating[]> => {
    return apiClient.get(`/api/users/${userId}/ratings`).then(res => res.data.data?.Ratings || []);
  },

  /**
   * Get average rating for a place (calculated from place.ratings array).
   * This is typically part of the place data, but included for completeness.
   */
  getPlaceRating: async (placeId: string): Promise<number | null> => {
    // Rating is typically part of place data
    // This method may not be needed if rating comes with place
    return null;
  },
};
